/**
 * R4's neutral line and its `Show` action.
 *
 * Revealing is local `useState`, deliberately with no callback and no
 * persisted flag: the component has nowhere else to remember it, so a
 * remount resets it. That is the mechanism that makes a reveal last "for
 * that one view only". This is unsubmitted view state, not overlay state, so
 * `url-state.mdc` does not apply here.
 *
 * The caller decides whether to mount this at all, using `isBlockedSender`
 * from `moderationRules.ts`. This component takes no `senderId` and no
 * blocklist.
 */
import { Button } from "@sportsmet/ui";
import { type ReactNode, useState } from "react";

import {
  BLOCKED_MESSAGE_LINE,
  SHOW_BLOCKED_MESSAGE_LABEL,
} from "./moderationCopy";

export type typeBlockedMessageLineProps = { children: ReactNode };

export const BlockedMessageLine = (
  props: typeBlockedMessageLineProps,
): ReactNode => {
  const [isRevealed, setIsRevealed] = useState(false);

  if (isRevealed) return props.children;

  return (
    <div
      data-testid="blocked-message-line"
      className="flex items-center justify-center gap-2 py-2 text-caption text-ink-secondary"
    >
      <span>{BLOCKED_MESSAGE_LINE}</span>
      <Button
        variant="link"
        size="sm"
        data-testid="blocked-message-show"
        onClick={() => {
          setIsRevealed(true);
        }}
      >
        {SHOW_BLOCKED_MESSAGE_LABEL}
      </Button>
    </div>
  );
};
